export const ICON_SPRITE_URL = window.bwst.ICON_SPRITE_URL || '/icons/icons.svg';
export const LANG = document.documentElement.lang || 'de';
export const API_URL = window.bwst.API_URL || '/api/';
export const ASSET_EXPORT_PATH = window.bwst.ASSET_EXPORT_PATH || '/dest/';

export const BREAKPOINTS = {
  xs: '0px',
  m: '600px',
  l: '1024px',
  xl: '1260px',
  xxl: '1920px',
};

export const MEDIA_QUERIES = {
  s: '(min-width: 0px)',
  m: '(min-width: 480px)',
  l: '(min-width: 768px)',
  xl: '(min-width: 1024px)',
};
